import type { CertificationPreview } from "./certifications.types";
import type { PortableTextBlock } from "./globals.types";
import type { Profession } from "./professions.types";

export interface EmailJourneyPreview {
	_id: string;
	title: string;
	slug: string;
	emailTemplates: EmailTemplate[];
	certifications: CertificationPreview[];
	professions: Profession[];
	utmParameters: {
		campaign: string;
	};
}

export interface EmailTemplate {
	_id: string;
	subject: string;
	preview: string;
	title: string;
	delay: number;
	body: PortableTextBlock[];
	notification: Notification;
	certifications: CertificationPreview[];
	professions: Profession[];
	utmParameters: utmParameters;
}

export interface Notification {
	_id: string;
	title: string;
	content: string;
	level: string;
	link: Link;
}

export interface Link {
	title: string;
	url: string;
}

export interface utmParameters {
	source: string;
	medium: string;
	campaign: string;
}

// https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#example
export class EmailJourneyError extends Error {
	name: string;
	cause: any;

	constructor(...args: any[]) {
		// 'Error' breaks prototype chain here
		super(...args);

		// set name
		this.name = new.target.name;
		Object.setPrototypeOf(this, new.target.prototype);
	}
}

export class AbandonedCartJourneyIdNotFoundError extends EmailJourneyError {}
